// Media URLs the browser fetches itself (same origin, session cookie). The HTTP cache is the
// "versioned disk cache": avatars are keyed by `last_picture_update`, files are immutable by id
// (shared/API.md §12.0), so a URL never changes meaning and the browser can keep it forever.
let base = '';

export function setMediaBase(baseUrl: string): void {
  base = baseUrl;
}

/** The server base every page-side URL is built on ('' = same origin). */
export function mediaBase(): string {
  return base;
}

export const mediaUrls = {
  avatar: (userId: string, version: number) => `${base}/api/v4/users/${userId}/image?_=${version}`,
  teamIcon: (teamId: string, version: number) => `${base}/api/v4/teams/${teamId}/image?_=${version}`,
  thumbnail: (fileId: string) => `${base}/api/v4/files/${fileId}/thumbnail`,
  preview: (fileId: string) => `${base}/api/v4/files/${fileId}/preview`,
  file: (fileId: string, download = false) => `${base}/api/v4/files/${fileId}${download ? '?download=1' : ''}`,
  customEmoji: (emojiId: string) => `${base}/api/v4/emoji/${emojiId}/image`,
};
